import socket, { connectWithAuth } from "../socket";
import Cookies from "js-cookie";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import AdminService from "../services/adminService";
import { useTranslation } from "react-i18next";

import NavbarOrganization from "../components/NavbarOrganization";
import SidebarOrganization from "../components/SidebarOrganization";
import WeddingForm from "../components/WeddingForm";
import AddGuest from "../components/AddGuest";
import AddTable from "../components/AddTable";
import Tables from "../components/Tables";
import AddFamily from "../components/AddFamily";
import GuestList from "../components/GuestList";
import NotificationBanner from "../components/NotificationBanner";
import { Helmet } from "react-helmet";

const AdminOrganizationPage = () => {
    const { t } = useTranslation();
    const [activeForm, setActiveForm] = useState("guests");
    const [tablesWithGuests, setTablesWithGuests] = useState([]);
    const [guests, setGuests] = useState([]);
    const [hasReservations, setHasReservations] = useState(false);

    const [showNotification, setShowNotification] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState("");
    const [errorResponse, setErrorResponse] = useState(false);

    const user = useSelector((state) => state.userStore.user);
    const refreshData = useSelector((state) => state.guestStore.refreshData);

    useEffect(() => {
        const hasAny = tablesWithGuests.some((table) => table.guests && table.guests.length > 0);
        setHasReservations(hasAny);
    }, [tablesWithGuests]);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [activeForm]);

    useEffect(() => {
        if (user.weddingId) {
            AdminService.getWeddingDetailsWithTablesAndGuests(user.weddingId)
                .then((res) => {
                    setTablesWithGuests(res.data.tablesWithGuests);
                    setGuests(res.data.guests);
                    // console.log(res.data.guests);
                })
                .catch((err) => {
                    //console.log(err.response.data.message);
                });
        }
    }, [user.weddingId, refreshData]);

    useEffect(() => {
        const token = Cookies.get("authToken");
        if (token && !socket.connected && user.weddingId) {
            connectWithAuth(); // spoji socket s tokenom
        }

        const handleConnect = () => {
            socket.emit("joinWeddingRoom", { weddingId: user.weddingId, isAdmin: true });
        };

        const handleTableUpdate = (tables) => {
            setTablesWithGuests(tables);
        };

        const handleGuestUpdate = (guests) => {
            setGuests(guests);
            setNotificationMessage(t("guestsUpdated"));
            setShowNotification(true);
            setTimeout(() => setShowNotification(false), 3000);
        };

        socket.on("connect", handleConnect);
        socket.on("tableUpdate", handleTableUpdate);
        socket.on("adminGuestListUpdate", handleGuestUpdate);

        // Ako je već spojen odmah pozovi
        if (socket.connected) {
            // console.log("Admin je već spojen");
            handleConnect();
        }

        return () => {
            socket.off("connect", handleConnect);
            socket.off("tableUpdate", handleTableUpdate);
            socket.off("adminGuestListUpdate", handleGuestUpdate);
        };
    }, [user.weddingId]);

    return (
        <>
            <Helmet>
                <title>{t('meta.organization.title')}</title>
                <meta name="description" content={t('meta.organization.description')} />
            </Helmet>
            <div className="flex flex-col items-center p-4 min-h-screen bg-gradient-to-br from-cyan-200 via-white to-pink-300 w-full">
                <NavbarOrganization activeForm={activeForm} setActiveForm={setActiveForm} guests={guests} tables={tablesWithGuests} hasReservations={hasReservations} />
                {showNotification && <NotificationBanner message={notificationMessage} onClose={() => setShowNotification(false)} />}
                {errorResponse && <NotificationBanner message={t("genericError")} onClose={() => setErrorResponse(false)} errorResponse={errorResponse} />}
                <SidebarOrganization activeForm={activeForm} setActiveForm={setActiveForm} guests={guests} tables={tablesWithGuests} hasReservations={hasReservations} />
                {!user.weddingId ? (
                    <div className="w-full flex justify-center pb-10 lg:ml-[120px] overflow-y-auto">
                        <div className="mt-12 lg:mt-0">
                            <h1 className="lg:text-3xl text-xl text-center font-bold lg:my-4 mx-2 text-gray-700 pb-5">
                                {t('registerStep3')}
                            </h1>
                            <h1 className="text-center text-gray-700 pb-5 mx-4">{t('registerStep3Info')}</h1>
                            <WeddingForm />
                        </div>
                    </div>
                ) :
                    <>
                        <div className="w-full">
                            {activeForm === "addGuest" && <AddGuest guests={guests} tables={tablesWithGuests} setActiveForm={setActiveForm} />}
                            {activeForm === "addFamily" && <AddFamily guests={guests} />}
                            {activeForm === "addTable" && <AddTable tables={tablesWithGuests} guests={guests} setActiveForm={setActiveForm} />}
                            {activeForm === "guests" && <GuestList guests={guests} tables={tablesWithGuests} setActiveForm={setActiveForm} setShowNotification={setShowNotification} setNotificationMessage={setNotificationMessage} setErrorResponse={setErrorResponse} />}
                            {activeForm === "tables" && <Tables tables={tablesWithGuests} setActiveForm={setActiveForm} setShowNotification={setShowNotification} setNotificationMessage={setNotificationMessage} setErrorResponse={setErrorResponse} />}
                        </div>
                    </>}
            </div >
        </>
    );
};


export default AdminOrganizationPage;
